import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import ScorecardBoard from "./ScorecardBoard";
import ScorecardHistory from "./ScorecardHistory";
import { fmtR, useScorecard } from "./useScorecard";

export function ProjectScorecardTab({ projectId }) {
  const sc = useScorecard({ projectId, includeClosed: true });
  return (
    <div className="space-y-4" data-testid="project-tab-scorecard">
      <ScorecardBoard projects={sc.projects} canEdit={sc.can_edit} onChanged={sc.reload}
        emptyText="This project isn't on the scorecard yet — add it from Team → Scorecard." />
      {sc.projects.length > 0 && <ScorecardHistory projectId={projectId} />}
    </div>
  );
}

export function EmployeeScorecardTab({ uid }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/scorecard/users/${uid}/summary`).then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [uid]);
  const total = items.reduce((a, r) => a + (r.balance || 0), 0);
  return (
    <div className="space-y-4" data-testid="employee-tab-scorecard">
      <div className="rounded-lg border border-white/10 overflow-x-auto">
        <table className="w-full min-w-[520px] text-xs">
          <thead><tr className="text-[10px] uppercase tracking-wider text-white/40">
            <th className="text-left py-1.5 pl-3">Project</th><th className="text-right">Budget</th><th className="text-right">Penalties</th>
            <th className="text-right">Rewards</th><th className="text-right pr-3">Balance</th></tr></thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.member_id} className="border-t border-white/5" data-testid={`employee-scorecard-project-${r.project_id}`}>
                <td className="py-1.5 pl-3"><Link to={`/projects/${r.project_id}`} className="text-white hover:underline">{r.project_name}</Link>
                  <span className="text-white/40"> · {r.project_status}{r.removed ? " · removed" : ""}</span></td>
                <td className="text-right font-mono">{fmtR(r.budget)}</td>
                <td className="text-right font-mono text-rose-300">−{fmtR(r.penalties)}</td>
                <td className="text-right font-mono text-emerald-300">+{fmtR(r.rewards)}</td>
                <td className={`text-right pr-3 font-mono font-semibold ${r.balance < 0 ? "text-rose-400" : "text-cyan-200"}`}>
                  {fmtR(r.balance)}{r.loan_id ? <span className="text-amber-300 font-normal"> · loan</span> : null}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="p-3 text-white/40">Not on any project scorecard yet.</td></tr>}
          </tbody>
          {items.length > 0 && <tfoot><tr className="border-t border-white/10"><td className="py-1.5 pl-3 text-white/60" colSpan={4}>Total balance</td>
            <td className={`text-right pr-3 font-mono font-semibold ${total < 0 ? "text-rose-400" : "text-cyan-200"}`}>{fmtR(total)}</td></tr></tfoot>}
        </table>
      </div>
      <ScorecardHistory userId={uid} showUser={false} />
    </div>
  );
}
